<div class="content">
  <div class="img-bg" [ngClass]="{'img-center': true}" [ngStyle]="styleObject">
    <img [src]="imageUrl" style="width: {{width}}; height: {{height}};" alt="background"/>
  </div>
  <ng-content></ng-content>
</div>

